var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-my-6 md:tw-my-12"},[_c('Inpatient'),_c('div',{staticClass:"tw-flex tw-justify-center tw-mt-4 md:tw-my-10"},[_c('AdditionalBenefits')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }